<p-toast></p-toast>
<app-topbar></app-topbar>
<main class="layout-container">
  <div class="layout-content-wrapper">
    <div class="layout-content">
      <div class="grid justify-content-center">
        <div class="col-12 md:col-10 form-container">
          <ng-template pTemplate="header">
            <div class="card-header">
              <h3 class="card-title">Editar prompt</h3>
            </div>
          </ng-template>
          <form [formGroup]="edicao">
            <p-card class="card custom-card">
              <div class="mx-2 field">
                <label for="titulo" class="font-normal">Título
                  <span class="text-red-500">*</span>
                </label>
                <input class="mt-1" pInputText required="true" formControlName="titulo" />
              </div>

              <div class="mx-2 mt-3 field">
                <label for="resumo" class="font-normal">Resumo
                  <span class="text-red-500">*</span>
                </label>
                <textarea class="mt-1" pInputTextarea required="true" rows="5" placeholder="Descrição"
                  [autoResize]="true" minlength="0" [maxlength]="MAX_RESUMO" formControlName="resumo"></textarea>
                <span class="text-500">
                  {{ qtdCaracteres('resumo') }} / {{ MAX_RESUMO }}
                </span>
              </div>

              <div class="mx-2 mt-3 field">
                <label for="prompt" class="font-normal">Prompt
                  <span class="text-red-500">*</span>
                </label>
                <textarea class="mt-1" pInputTextarea required="true" rows="10" placeholder="Descreva seu prompt"
                  [autoResize]="true" minlength="0" [maxlength]="MAX_PROMPT" formControlName="prompt"></textarea>
                <span class="text-500">
                  {{ qtdCaracteres('prompt') }} / {{ MAX_PROMPT }}
                </span>

              </div>

              <div class="mx-2 mt-3 field">
                <label for="instrucoes" class="font-normal">Orientação
                </label>
                <textarea maxlength="1200" class="mt-1" pInputText required="true" rows="5"
                  placeholder="Descreva seu prompt" formControlName="instrucoes">
                  </textarea>
              </div>

              <div class="mx-2 mt-3 field">
                <label for="tags" class="font-normal text-600">Palavras-chave (opcional)</label>
                <div class="tags-container">
                  <div class="tag" *ngFor="let tag of tags">
                    {{ tag }}
                    <span class="remove-tag" (click)="removeTag(tag)">×</span>
                  </div>
                  <input type="text" class="tag-input" placeholder="Separe com vírgula: habeas corpus, indenização moral, ação civil" (keydown)="onTagInput($event)" (paste)="onPaste($event)" />
                </div>
              </div>

            </p-card>

            <br>
            <p-card class="card custom-card">
              <ng-template pTemplate="header">
                <div class="card-header">
                  <h3 class="card-title">Caracterização e Finalidade<span class="text-red-500">*</span></h3>
                </div>
              </ng-template>

              <div class="grid caracterizacao-grid">
                <div class="col-12 lg:col-4">
                  <div class="h-full">
                    <div class="p-2 h-full flex flex-column border-1 surface-border border-round caracterizacao-card" style="border-radius: 6px">
                      <div class="text-900 font-bold text-base">Tipo de Processo</div>
                      <hr class="caracterizacao-hr mx-0 border-top-1 border-none surface-border" />
                      <div class="flex flex-column caracterizacao-opcoes">
                        <div *ngFor="let categoria of filtrarCategoriasProcessOrdenadas" class="field-checkbox">
                          <label>
                            <input type="checkbox" class="custom-caract-checkbox" [checked]="selecionadoCaractFinalidade(categoria)"
                              (change)="alterarSelecaoCaractFinalidade(categoria)" />
                            {{ categoria.categoria_descricao }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 lg:col-4">
                  <div class="h-full">
                    <div class="p-2 h-full flex flex-column border-1 surface-border border-round caracterizacao-card"
                      style="border-radius: 6px">
                      <div class="text-900 text-base font-bold">Instância</div>
                      <hr class="caracterizacao-hr mx-0 border-top-1 border-none surface-border" />

                      <div class="flex flex-column caracterizacao-opcoes">
                        <div *ngFor="let categoria of filtrarCategoriasInsOrdenadas" class="field-checkbox">
                          <label>

                            <input type="checkbox" class="custom-caract-checkbox"
                              [checked]="selecionadoCaractFinalidade(categoria)"
                              (change)="alterarSelecaoCaractFinalidade(categoria)" />
                            {{ categoria.categoria_descricao }}
                          </label>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 lg:col-4">
                  <div class="h-full">
                    <div class="p-2 h-full flex flex-column border-1 surface-border border-round caracterizacao-card"
                      style="border-radius: 6px">
                      <div class="text-900 font-bold">Justiça</div>
                      <hr class="caracterizacao-hr mx-0 border-top-1 border-none surface-border" />

                      <div class="flex flex-column caracterizacao-opcoes">
                        <div *ngFor="let categoria of filtrarCategoriasJusOrdenadas" class="field-checkbox">
                          <label>
                            <input type="checkbox" class="custom-caract-checkbox"
                              [checked]="selecionadoCaractFinalidade(categoria)"
                              (change)="alterarSelecaoCaractFinalidade(categoria)" />
                            {{ categoria.categoria_descricao }}
                          </label>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 lg:col-12">
                  <div class="h-full">
                    <div class="p-2 h-full flex flex-column border-1 surface-border border-round caracterizacao-card"
                      style="border-radius: 6px">
                      <div class="text-900 font-bold">Área de Direito</div>
                      <hr class="caracterizacao-hr mx-0 border-top-1 border-none surface-border" />

                      <div class="area-direito-grid">
                            <div *ngFor="let categoria of filtrarCategoriasAreaDirOrdenadas" class="field-checkbox">
                              <label>
                                <input type="checkbox" class="custom-caract-checkbox"
                                  [checked]="selecionadoCaractFinalidade(categoria)"
                                  (change)="alterarSelecaoCaractFinalidade(categoria)" />
                                {{ categoria.categoria_descricao }}
                              </label>
                            </div>
                      </div>

                    </div>
                  </div>
                </div>

                <div class="dropdown">
                  <div class="mx-2 mt-3 field">
                    <label for="tags" class="font-normal"> Finalidade </label>
                    <span class="text-red-500">*</span>

                    <div class="dropdown-header" (click)="alterarDropdown()">
                      <span *ngIf="selecionarCategorias.length > 0; else placeholder">
                        {{ descricaoCategoriasSelecionadas }}
                      </span>
                      <ng-template #placeholder>
                        Selecione as Finalidades
                      </ng-template>
                      <span class="arrow">{{ dropdownCategoria ? '▲' : '▼' }}</span>
                    </div>

                    <div class="dropdown-content" *ngIf="dropdownCategoria">
                      <div class="search-container">
                        <input type="text" formControlName="pesquisaCategoria" (input)="filtrarCategoria()"
                          placeholder="Pesquisar..." class="search-input" />
                        <span class="search-icon">🔍</span> <!-- Ícone de lupa -->
                      </div>
                      <ul>
                        <li *ngFor="let categoria of filtrarCategoriasOrdenadas">
                          <label>
                            <input type="checkbox" [checked]="selecionado(categoria)"
                              (change)="alterarSelecao(categoria)" />
                            {{ categoria.categoria_descricao }}
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="mx-2 mt-3">
                  <label>
                    <input type="checkbox" formControlName="anonimo"
                      (change)="toggleCheckbox(edicao.get('anonimo')?.value)" />
                    Deseja salvar como usuário anônimo?
                  </label>
                </div>

                <div class="mx-2 mt-3">
                  <label>
                    <input type="checkbox" formControlName="termo"
                      (change)="toggleCheckboxTermo(edicao.get('termo')?.value)" />
                    Eu confirmo que sou o titular dos direitos autorais sobre o conteúdo que estou submetendo e concordo
                    com cessão de direitos autorais para a plataforma de Prompt do Tribunal de Justiça do Estado do Pará
                    para utilizar, reproduzir, modificar, adaptar e exibir este conteúdo.
                  </label>
                </div>

                <div class="mx-2 mt-3 flex gap-2">
                  <p-button pRipple label="Salvar" (click)="atualizarPrompt()"></p-button>
                  <p-button pRipple severity="secondary" label="Voltar" [routerLink]="'/painel'"></p-button>
                </div>
              </div>

            </p-card>
          </form>
        </div>
      </div>
    </div>
  </div>
</main>
